import React, { useEffect, useState } from "react";
import { AFFILIATE } from "../lib/api";
import { BedDouble } from "lucide-react";
import { trackAffiliateClick } from "../lib/analytics";

const StickyCTA = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={AFFILIATE.booking}
      target="_blank"
      rel="noopener noreferrer sponsored"
      data-testid="sticky-check-hotels-cta"
      onClick={() => trackAffiliateClick({ label: "Check Hotel Prices", category: "hotel", destination: AFFILIATE.booking, location: "sticky" })}
      className={`fixed z-40 bottom-5 right-5 md:bottom-8 md:right-8 inline-flex items-center gap-2 btn-primary-gradient text-white rounded-full px-5 py-3.5 md:px-6 md:py-4 font-semibold shadow-[0_12px_32px_rgba(255,140,0,0.35)] transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"
      }`}
    >
      <BedDouble className="w-5 h-5" />
      <span>Check Hotel Prices</span>
    </a>
  );
};

export default StickyCTA;
